import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=0109c606&scoped=true&"
import script from "./empty.vue?vue&type=script&lang=ts&"
export * from "./empty.vue?vue&type=script&lang=ts&"
import style0 from "./empty.vue?vue&type=style&index=0&id=0109c606&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0109c606",
  null
  
)

export default component.exports